import { memo, useCallback } from 'react'
import { RightDetailView } from '../rightDetailView/RightDetailView'
import { getRelativeURLKeepingQuerySearch } from '../../helpers/routeHelper'
import { MainLayout } from '../../components/layout/MainLayout'
import { ProjectLevelTopBar } from '../project/ProjectLevelTopBar'
import { itemHelper } from '../../common/src/helpers'
import { MatrixTableComponent } from './MatrixTableComponent'
import { uriDataCreator } from '../../common/src/helpers/URLHelper'
import { PM_API_RESOURCE_TYPE } from '../../common/src/constants'
import { linkSubject, SOURCES } from '../../reactions/linkSubject'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { addItemIdToRecentlyVisited } from '../../actions/uiActions'

export const MatrixTableView = memo(
  ({ project, items, sortFn, loading, projectSelectorEnabled = true, readOnly = false, showOwner = true }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const onClickItem = useCallback(({ rowData: item }) => {
      const serverID = itemHelper.getId(item)
      const urlData = uriDataCreator(1, PM_API_RESOURCE_TYPE.ITEM, serverID)
      
      // Explicitly add this item to recently visited, regardless of navigation
      dispatch(addItemIdToRecentlyVisited(serverID))
      
      // Continue with normal navigation
      linkSubject.next({ urlData, source: SOURCES.LIST })
    }, [dispatch])

    const main = (
      <div className="flex h-full flex-col">
        <MatrixTableComponent
          project={project}
          items={items}
          onSelectItem={onClickItem}
          sortFn={sortFn}
          loading={loading}
          readOnly={readOnly}
          showOwner={showOwner}
        />
        <div className="flex justify-center px-2 py-1">{t('project_view.current_count', { count: items?.size })}</div>
      </div>
    )
    const detail = <RightDetailView readOnly={readOnly} />
    const topBar = (
      <ProjectLevelTopBar
        getNavigationURLForProjectId={getRelativeURLKeepingQuerySearch.listForProjectId}
        key={'ProjectMatrixViewTopBar'}
        project={project}
        projectSelectorEnabled={projectSelectorEnabled}
        readOnly={readOnly}
        items={items}
      />
    )
    return <MainLayout main={main} rightSide={detail} topBar={topBar} />
  }
)
